import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
// Add your imports here
import AdminLogin from "pages/admin-login";
import DashboardOverview from "pages/dashboard-overview";
import CardManagement from "pages/card-management";
import BillingManagement from "pages/billing-management";
import ReportsAnalytics from "pages/reports-analytics";
import UserManagement from "pages/user-management";
import TokenManagement from "pages/user-token";
import AllContact from "./pages/contacts/AllContact";
import Providers from "./pages/provider/Providers";
import Login from "./pages/Login";
import NotFound from "pages/NotFound";
import ProtectedRoute from "hooks/ProtectedRoute";
import ProtectedBack from "hooks/ProtectedBack";

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          {/* Define your routes here */}
          <Route
            path="/login"
            element={
              <ProtectedBack>
                <Login />
              </ProtectedBack>
            }
          />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <DashboardOverview />
              </ProtectedRoute>
            }
          />
          <Route path="/admin-login" element={<AdminLogin />} />
          <Route path="/dashboard-overview" element={<DashboardOverview />} />
          <Route path="/card-management" element={<CardManagement />} />
          <Route path="/billing-management" element={<BillingManagement />} />
          <Route path="/reports-analytics" element={<ReportsAnalytics />} />
          <Route path="/user-management" element={<UserManagement />} />
          <Route path="/token-management" element={<TokenManagement
TokenManagement />} />
          <Route path="/provider-management" element={<Providers />} />
          <Route path="/contacts" element={<AllContact />} />
          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
